export default __webpack_public_path__ + "static/ios14-with-chrome-073a712efc8f59b9685d6cca535ed530.jpg";